import {useQuery} from "@tanstack/react-query";
import {useEffect, useState} from "react";
import {getFacilities} from "../services/FacilityService";
import {useLogout} from "./useLogout";

export function useFacilities({page, size, businessUnitCodes, enabled = true}) {
    const [facilities, setFacilities] = useState([]);
    const [totalCount, setTotalCount] = useState(0);

    const codes = businessUnitCodes ?? [];

    const logout = useLogout();
    const {data, isError, error, refetch} = useQuery({
        queryKey: ["facilities", page, size, codes],
        queryFn: () => getFacilities({page, size, businessUnitCodes: codes}),
        enabled,
        retry: false,
    });

    useEffect(() => {
        if (isError && error.response && error.response.status) {
            if (error.response.status === 401) {
                logout();
            }
        }
    }, [isError, error]);

    useEffect(() => {
        if (data) {
            const transformData = data.facilities?.map((facility) => {
                let address = [facility?.address1, facility?.address2].filter(Boolean).join(", ");
                let timeZoneId = facility?.timeZone?.zoneId ?? ''
                return {
                    ...facility,
                    address,
                    timeZoneId
                };
            });
            setFacilities(transformData);
            setTotalCount(data.totalCount);
        }
    }, [data]);

    return [facilities, totalCount, refetch];
}
